import type { MlsFeed } from '~/modules/query/mls';

/** One bay target (ClientBAY / SocialBAY) a feed is connected to. */
export interface MlsTarget {
  key?: string;
  associatedCustomers?: { name: string }[];
}

/** A feed row as the table reads it; `MlsFeed` only declares the ids. */
export interface MlsRow extends MlsFeed {
  name?: string;
  iconUrl?: string;
  vendor?: string;
  feed_id?: string;
  dtLastDownload?: string;
  dtLastDownloadFull?: string;
  dataServer?: string;
  dmServer?: string;
  targets?: Record<string, MlsTarget | undefined>;
}

export const MLS_STAT_TITLES: Record<string, string> = {
  nTot: 'Feed count',
  nHavingSoldStatus: 'Feed count with sold',
  nConnectedToSocialBay: 'SocialBAY feed count',
  nConnectedToClientBay: 'ClientBAY feed count',
};
